import React, { useEffect, useState } from "react";
import { FilterProperties } from "../../Models/FilterProperties";
import { Button, Popover, Box } from "@mui/material";


const SortByStatus: React.FunctionComponent<{ filterOptionsValue: FilterProperties, OnSelectChangeSortBy: any }> = (props) => {

    const [filterOptions, setFilterOptions] = useState<FilterProperties>(props.filterOptionsValue);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;

    useEffect(() => {
        setFilterOptions(props.filterOptionsValue)
    })

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };


    const handleChange = (value: string) => {
        setFilterOptions((prevState) => {
            const newState = {
                ...prevState,
                status: prevState.status === value ? "" : value,
            };
            props.OnSelectChangeSortBy(newState);
            return newState;
        });
    };

    return (

        <Box>
            <button
                className="border-trans back-trans "
                type="button"
                onClick={handleClick}
            >
                <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_23_466)">
                        <path d="M4.5 6L8.5 10L12.5 6" stroke="#475569" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_23_466">
                            <rect width="16" height="16" fill="white" transform="matrix(1 0 0 -1 0.5 16)" />
                        </clipPath>
                    </defs>
                </svg>
            </button>

            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center",
                }}
                PaperProps={{
                    sx: {
                        padding: 0,
                        overflow: "visible",
                        background: "#FFFFFF",
                        borderRadius: "12px",
                        marginTop: "15px",
                        boxShadow: "0px 4px 48px rgba(0, 0, 0, 0.25) !important"
                    },
                }}
            >
                <Box
                    sx={{
                        position: "relative",
                        display: "flex",
                        backgroundColor: "white",
                        padding: "10px 15px",
                        borderRadius: "7px"
                    }}
                >
                    <Box
                        sx={{
                            position: "absolute",
                            top: "-10px",
                            left: "50%",
                            width: "0",
                            height: "0",
                            borderLeft: "10px solid transparent",
                            borderRight: "10px solid transparent",
                            borderBottom: "10px solid white",
                            transform: "translateX(-50%)",
                        }}
                    />
                    <div className="">
                        {["Published", "Unpublished", "Draft"].map((status) => (
                            <label key={status} className="status-option">
                                <input
                                    type="checkbox"
                                    className="form-check-input"
                                    name="status"
                                    value={status}
                                    checked={filterOptions.status === status}
                                    onChange={() => handleChange(status)}
                                />
                                {status}
                            </label>
                        ))}

                    </div>

                </Box>
            </Popover >
        </Box >
    );
};

export default SortByStatus;
